module.exports = __webpack_public_path__ + "static/img/SAM-GRLJ.a26b0d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM-GRLJ.jpg
// module id = Tw9G
// module chunks = 0